import PropTypes from 'prop-types'
import Icon from '../Icon'

const ActionButton = ({icon, className, onClick, title}) => {
  return (
    <button title={title} onClick={onClick} className={`action-button ${className}`}>
      <Icon className="icon" svg={icon} color="var(--text-color)" />
    </button>
  )
}

ActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
}

ActionButton.defaultProps = {
  className: '',
  title: '',
}

export default ActionButton
